import React from "react";
import { connect } from "react-redux";
import { AvField, AvForm } from "availity-reactstrap-validation";

import { EMPTY_STRING, eventDetailsFields } from "../../../../constants";
import { eventBookingActions } from "../../../../redux/actions";

const { EVENT_TYPE, NAME } = eventDetailsFields;

const EventTypeForm = (props) => {
  const { currentEventType, selectedEventId, onChange, onGenerateShotlist } =
    props;

  const handleChange = (e) => {
    const { name, value } = e.target;

    onChange(selectedEventId, EVENT_TYPE, { [name]: value });
  };

  const handleSubmit = (_event, value) => {
    props.getEventTypeShotList(
      JSON.stringify(value[eventDetailsFields.NAME]),
      selectedEventId,
      props.formState
    );
    onGenerateShotlist();
  };

  return (
    <div className="event-type event-type-form px-4">
      <h4 className="event-type-title label-content-600">
        tell us what kind of event you're hosting
      </h4>
      <p className="event-type-description mb-2">
        for example, a leadership conference or a holiday party. this helps us
        build a customized shot list for your event.
      </p>
      <AvForm id="event-details-type-form" onValidSubmit={handleSubmit} autoComplete="off">
        <div className="row">
          <div className="col-12 p-0">
            <AvField
              key={selectedEventId}
              name={NAME}
              type="text"
              className="form-control"
              value={currentEventType?.eventType?.name || EMPTY_STRING}
              onChange={handleChange}
              maxLength="70"
              validate={{
                required: {
                  value: true,
                  errorMessage: "Please enter an event type",
                },
              }}
            />
          </div>
        </div>
        <div className="d-flex justify-content-start mt-4 mb-3 mb-lg-0">
          <button type="submit" className="button-common button-fill">
            generate shotlist
          </button>
        </div>
      </AvForm>
    </div>
  );
};

// Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({
  formState: state.eventBooking.formState,
  selectedEventId: state.eventBooking.selectedEventId,
  currentEventType: state.eventBooking.currentEventType,
});

// Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({
  getEventTypeShotList: (body, eventId, formState) =>
    dispatch(
      eventBookingActions.getEventTypeShotList(body, eventId, formState)
    ),
});

// mapping action and store the function via props
export default connect(mapStateToProps, mapDispatchToProps)(EventTypeForm);
